import { NodeTypes } from '@xyflow/react';
import NodeWrapper from './NodeWrapper';
import NoteNode from './NoteNode';

// Node type configuration interface
export interface NodeTypeConfig {
  component: React.ComponentType<any>;
  showPropertiesPanel?: boolean; // Whether this node type should show properties panel on double-click
}

// Node type configurations with metadata
const nodeTypeConfigs: Record<string, NodeTypeConfig> = {
  // Special node types
  note: { component: NoteNode, showPropertiesPanel: false },

  // Default types for transforms/actions
  genericStep: { component: NodeWrapper, showPropertiesPanel: true },
  transform: { component: NodeWrapper, showPropertiesPanel: true },
  action: { component: NodeWrapper, showPropertiesPanel: true },
  
  // Add a default for any other node type
  unknown: { component: NodeWrapper, showPropertiesPanel: true },
};

// Extract just the components for ReactFlow
const nodeTypes: NodeTypes = Object.fromEntries(
  Object.entries(nodeTypeConfigs).map(([key, config]) => [key, config.component])
);

// Helper function to check if a node type should show properties panel
export const shouldShowPropertiesPanel = (nodeType: string): boolean => {
  return nodeTypeConfigs[nodeType]?.showPropertiesPanel ?? true; // Default to true for unknown types
};

export default nodeTypes;
